module.exports = __webpack_public_path__ + "static/media/map-pin.d02f6594.png";